import styled from '@emotion/styled';
import { Button } from '@material-ui/core';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ImageIcon from '@material-ui/icons/Image';
import React from 'react';
import officeFloorPlan from '../../../assets/office-floor-plan.png';
import { Box } from '../../UI';
import TextBox from '../../UI/TextBox';



export default function FloorPlan({ active }) {
	const [description, setDescription] = React.useState('');
	return (
		<Box>
			<ExpansionPanel>
				<ExpansionPanelSummary
					expandIcon={<ExpandMoreIcon />}
					aria-controls="panel1a-content"
					id="panel1a-header"
				>
					<Typography variant="h6"><strong>Floorplan</strong></Typography>
				</ExpansionPanelSummary>
				<ExpansionPanelDetails>
					<Box display="flex" flexDirection="column" width="100%">
						<div style={{ marginBottom: '0.5rem' }}>
							<input
								color="primary"
								accept="image/*"
								type="file"
								onChange={false}
								id="icon-button-file"
								style={{ display: 'none' }}
							/>
							<label htmlFor="icon-button-file">
								<Button
									variant="contained"
									component="span"
									color="primary"
									startIcon={<ImageIcon />}
								>
									Upload image
								</Button>
							</label>
						</div>
						{active && <Image src={officeFloorPlan} alt="Office Floor Plan" style={{ marginBottom: '1rem' }}/>}
						<TextBox 
							value={description}
							onChange={setDescription}
							rows={2}
							label='Description'
						/>
					</Box>
				</ExpansionPanelDetails>
			</ExpansionPanel>
		</Box>
	);
}

const Image = styled.img`
	width: 100%;
`;
